<div [formGroup]="parentGroup" class="border-area">
    <div formArrayName="subFieldConf">
        <h4 class="my-0 mb-2" style="font-weight:normal;">Selection-Konfiguration</h4>

        <ng-template #subFieldTemplate let-formArray let-depth="depth">
            @for (opt of getControls(formArray); track opt) {
                @if (getFormGroup(opt)) {
                    <div [formGroup]="getFormGroup(opt)!" class="border-area">

                        <!-- Option row -->
                        <div class="option-row">
                            <mat-form-field>
                                <mat-label>{{ depth > 0 ? 'Unterfeld Label' : 'Label' }}</mat-label>
                                <input matInput formControlName="label" required />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>{{ depth > 0 ? 'Unterfeld Name' : 'Name' }}</mat-label>
                                <input matInput formControlName="name" required />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Typ</mat-label>
                                <mat-select formControlName="datatype">
                                    @for (dt of datatypeOptions; track dt) {
                                        <mat-option [value]="dt">{{ dt }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <button mat-icon-button color="warn" (click)="removeSubField(formArray, $index)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>

                        <!-- Nested subFieldConf (recursive) -->
                        <div class="sub-config border-area" formArrayName="subFieldConf">
                            <ng-container *ngTemplateOutlet="subFieldTemplate; context: {
                                $implicit: getSubFieldConf(getFormGroup(opt)!),
                                depth: depth + 1
                            }"></ng-container>

                            <button mat-stroked-button (click)="addSubField(getFormGroup(opt)!)">
                                Unterfeld hinzufügen
                            </button>
                        </div>

                    </div>
                }
            }
        </ng-template>

        <ng-container *ngTemplateOutlet="subFieldTemplate; context: {
            $implicit: options,
            depth: 0
        }"></ng-container>

    </div>

    <button mat-raised-button color="primary" (click)="addSubField(parentGroup)">
        Option hinzufügen
    </button>
</div>
